<div class="export-modal">
  <button class="close" (click)="onClose()"><mat-icon>close</mat-icon></button>

  <h2>Email Report</h2>
  <p class="subtitle">Select the file type you would like to send to your email</p>

  <div class="format-tabs">
    <button
      [class.active]="selectedFormat === ExportFormatEnum.xlsx"
      (click)="selectFormat(ExportFormatEnum.xlsx)"
      class="left-button"
    >
      <img src="shared-assets/icons/excel.png" alt="Excel Icon" class="icon" />
      Excel file
    </button>

    <button [class.active]="selectedFormat === ExportFormatEnum.pdf" (click)="selectFormat(ExportFormatEnum.pdf)">
      <img src="shared-assets/icons/pdf.png" alt="PDF Icon" class="icon" />
      PDF file
    </button>

    <button
      [class.active]="selectedFormat === ExportFormatEnum.csv"
      (click)="selectFormat(ExportFormatEnum.csv)"
      class="right-button"
    >
      <img src="shared-assets/icons/csv.png" alt="CSV Icon" class="icon" />
      CSV file
    </button>
  </div>

  <form [formGroup]="exportEmailForm">
    <div>
      <app-text-input
        formControlName="email"
        [showCopyIcon]="false"
        label="Email"
        placeholder="Enter email"
        [isInvalid]="getFieldError('email') !== ''"
        [errorMessage]="getFieldError('email')"
      ></app-text-input>
    </div>

    <div formArrayName="extraEmails">
      @for (extraEmail of extraEmailsArray.controls; track extraEmail; let i = $index) {
      <div class="extra-emails" animate.enter="expand-in" animate.leave="collapse-out">
        <app-text-input
          [formControlName]="i"
          [showCopyIcon]="false"
          label="Email"
          placeholder="Enter email"
          [isInvalid]="getExtraEmailError(i) !== ''"
          [errorMessage]="getExtraEmailError(i)"
          class="email-input"
        ></app-text-input>

        <button type="button" (click)="removeEmail(i)" [matTooltip]="'Remove email'" matTooltipPosition="above">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
      }
    </div>

    <app-button buttonVariant="export-link" buttonType="button" [state]="addMoreButtonState" (buttonClick)="addEmailField()">Add more email address</app-button>
  </form>

  <div class="button-container">
    <app-button buttonVariant="export-primary" buttonType="button" [state]="exportButtonState" (buttonClick)="onExport()">Export</app-button>
  </div>
  @if (loading) {
  <app-loading-spinner size="large" [isOverlay]="true"></app-loading-spinner>
  }
</div>
